 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.core-js","19":"npm.create-react-class","20":"npm.d3-scale","21":"npm.dompurify","22":"npm.react-querybuilder","23":"npm.react-smooth","24":"npm.react-sortable-hoc","25":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"a2aa61b09e52766619ba","5":"2d7bb08d91e67f3c8f6a","6":"b60353fe52070d422928","7":"6d3ad3a1eaa54d06bf6c","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"fb00abbe59df339b98b2","14":"1b625f3378a9db60bbef","17":"d2a7ae28e5ef57d500ca","18":"aeda64833536ef365e2a","19":"df2336024ddc5dc39567","20":"53276394962f6600858a","21":"4753773ccd4f3f64929c","22":"aea9a033bfa0e2e2ff81","23":"60be86c4cd67c3937270","24":"754bb30c4f2a452a4882","25":"9df6564a3d733b74319f","27":"02420ecb6c36c38d4af1","28":"a9cfa75ee0f54f26a66c","29":"601940546f4de32be9ed","30":"dc2780db7d7861b04582","31":"c2cadbc95d922ca38476","32":"ac7fed0377b8e4bdae81","33":"8670647fd66fa4b5b8b4","34":"f6abddb12d76ff82cd8d","35":"5cdc77e2f81f651b52f5","36":"c01e1eb70217ac89eec8","37":"39c901969f382ae03629","38":"1ddb426fe44f9aed9265","39":"5b77e322cc6230865821","40":"dd0d5ff6e0301e4d3fad","41":"18d624dc05c02589bb67","42":"2bff61ca83af2ddb9a90","43":"d2a34d044df770e77f92","44":"6f646694ec0bc843e696","45":"549ac4914cad99a8864f","46":"124d585f1b7417200ff1","47":"46da6c1fb3dad1313b28","48":"7d4cd1a13491bb04b858","49":"5e6d164bfc59fb213ef6","50":"88dd476915ab3667272a","51":"8f2726b98f26a381b180","52":"71053c646ba8bd0b8bbe","53":"c97305ad37d5d7e54c46","54":"1861b28d7d5a5f5f4e78","55":"8fbf8b7c3d8f4c2e35f9","56":"ab2a484822858db98e57","57":"3b72489a6be91631e10d","58":"213018aceeb0b91d22de","59":"6881a6d239913f2eb83d","60":"fd4c43419956db937c86","61":"0150446500c82bab0227","62":"10c7fc1fad2a087dbd83","63":"6ab5b8215e8478f11279","64":"09d9a2550ef95bb7eb90","65":"b1014b4114718c347946","66":"664446ad27b3c37757e6","67":"7c3dc52e3654b7a72851","68":"ced10594a2a87ba0bcc7","69":"8db55049c1d7a2df52c5","70":"f7570b2e93261d44f226","71":"ee0d12f8ceb3d4e8adaf","72":"19478f7a2509ec50c3a2","73":"037f1fb07b5b3ea2df4d","74":"854f90a59deeffa36b17","75":"46f4af4541ee5a680eb4","76":"b66bc4528da8de699271","77":"3933dfb5e46103ac46f7","78":"8d32d845de660019e44b","79":"37167402111fe2194b70","80":"95258d953bd8079bba60","81":"b433d713754ce7c92d36","82":"95a57813d6b7b79fef4f","83":"d6ba6fb2d0f2beaf6559","84":"fd36171a9c262166dda8","85":"a82a3ec3cbabff0ccc54","86":"7ef27057886f96e4835e","87":"1829655e384ade79b057","88":"98dcc421730df0302038","89":"34c8bcd6e51e3db01612","90":"33219185985cf4aad06b","91":"49c0ae2bdcb6e497b22a","92":"1106f00c383df47214f8","93":"9bdcd56e39f847722b93"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/e75e2cb/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
